import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';

import berryIcon from '../../lib/libraries/extensions/berry/berry-icon.svg';
import {markVersionSeen} from '../../lib/version-check';

import styles from './update-modal.css';

// 将 **bold** 转为 React 元素数组
const renderInline = text => {
    const parts = String(text).split(/(\*\*.+?\*\*)/g);
    return parts.map((part, i) => {
        if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        return part;
    });
};

// 将 Markdown 纯文本渲染为 React 元素
const renderChangelog = text => {
    if (!text) return null;
    const lines = String(text).split('\n');
    const elements = [];
    let listItems = [];

    const flushList = key => {
        if (listItems.length > 0) {
            elements.push(
                <ul key={key}>
                    {listItems.map((item, i) => (
                        <li key={i}>{renderInline(item)}</li>
                    ))}
                </ul>
            );
            listItems = [];
        }
    };

    lines.forEach((line, idx) => {
        const trimmed = line.trim();
        if (trimmed.startsWith('# ')) {
            flushList(`list-${idx}`);
            elements.push(<h3 key={`h-${idx}`}>{trimmed.slice(2)}</h3>);
        } else if (trimmed.startsWith('## ')) {
            flushList(`list-${idx}`);
            elements.push(<h4 key={`h-${idx}`}>{trimmed.slice(3)}</h4>);
        } else if (trimmed.startsWith('- ') || trimmed.startsWith('* ')) {
            listItems.push(trimmed.slice(2));
        } else if (trimmed === '') {
            flushList(`list-${idx}`);
        } else {
            flushList(`list-${idx}`);
            elements.push(<p key={`p-${idx}`}>{renderInline(trimmed)}</p>);
        }
    });
    flushList('list-final');
    return elements;
};

class UpdateModal extends React.PureComponent {
    constructor (props) {
        super(props);
        this.handleLater = this.handleLater.bind(this);
        this.handleViewDetails = this.handleViewDetails.bind(this);
    }
    handleLater () {
        const {updateInfo, onRequestClose} = this.props;
        if (updateInfo) {
            markVersionSeen(updateInfo.latestVersion);
        }
        onRequestClose();
    }
    handleViewDetails () {
        const {updateInfo, onViewDetails} = this.props;
        if (updateInfo) {
            markVersionSeen(updateInfo.latestVersion);
        }
        onViewDetails();
    }
    render () {
        const {updateInfo} = this.props;
        if (!updateInfo) return null;

        return (
            <ReactModal
                isOpen
                className={styles.modalContent}
                contentLabel="BerryEditor Update Available"
                overlayClassName={styles.modalOverlay}
                onRequestClose={this.handleLater}
            >
                <div className={styles.modalHeader}>
                    <img
                        className={styles.headerIcon}
                        src={berryIcon}
                        draggable={false}
                        alt=""
                    />
                    <h2 className={styles.headerTitle}>
                        {'发现新版本 '}{updateInfo.latestVersion}
                    </h2>
                    <div className={styles.headerSubtitle}>
                        {'BerryEditor 有更新可用'}
                    </div>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.versionInfo}>
                        <div className={styles.versionItem}>
                            <span className={styles.versionLabel}>{'当前版本'}</span>
                            <span className={styles.versionValue}>{updateInfo.currentVersion}</span>
                        </div>
                        <span className={styles.versionArrow}>{'→'}</span>
                        <div className={styles.versionItem}>
                            <span className={styles.versionLabel}>{'最新版本'}</span>
                            <span className={`${styles.versionValue} ${styles.new}`}>
                                {updateInfo.latestVersion}
                            </span>
                        </div>
                    </div>
                    {updateInfo.releaseNotes && (
                        <React.Fragment>
                            <div className={styles.changelogTitle}>{'更新内容'}</div>
                            <div className={styles.changelog}>
                                {renderChangelog(updateInfo.releaseNotes)}
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className={styles.modalFooter}>
                    <button
                        className={`${styles.btn} ${styles.btnSecondary}`}
                        onClick={this.handleLater}
                    >
                        {'稍后再说'}
                    </button>
                    <button
                        className={`${styles.btn} ${styles.btnPrimary}`}
                        onClick={this.handleViewDetails}
                    >
                        {'查看详情'}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

UpdateModal.propTypes = {
    updateInfo: PropTypes.shape({
        currentVersion: PropTypes.string,
        latestVersion: PropTypes.string,
        releaseUrl: PropTypes.string,
        releaseNotes: PropTypes.string
    }),
    onRequestClose: PropTypes.func.isRequired,
    onViewDetails: PropTypes.func.isRequired
};

export default UpdateModal;
